<script lang="ts">
	export let text;
</script>

<div class="flex flex-col items-center">
	<p class="text-2xl font-bold overflow-hidden text-ellipsis max-w-[80vw] md:max-w-[80vw] px-8">
		{text}
	</p>
	<div class="col-start-1 col-span-3 mt-2 border-t-2 border-gray border-dotted w-full" ></div>
</div>
